/**
 * UI_VERSION
 *
 * Bumped by hand whenever a deliberate design/layout change ships. This is
 * independent of the per-commit git hash (which changes with every deploy).
 * If the rendered UI looks like an older design, compare UI_VERSION on
 * /status against the expected value — any mismatch is a caching or bundle
 * problem, not a CSS regression.
 *
 * Bump rules:
 *   Major (v2 → v3):  redesign of header / hero / overall layout
 *   Minor (v2 → v2.1): new design tokens, spacing pass, typography
 *   Patch is not tracked here (use git hash).
 */
export const UI_VERSION = 'v3.1';
